let isSettingCartAddons = false;

function waitForMinimogEvents() {
  if (window.MinimogEvents) {
    window.MinimogEvents.subscribe("cart-update", setCartAddons);
    window.MinimogEvents.subscribe("open-cart-drawer", setCartAddons);
  } else {
    requestAnimationFrame(waitForMinimogEvents);
  }
}
waitForMinimogEvents();

async function setCartAddons() {
  if (isSettingCartAddons) {
    return;
  }

  isSettingCartAddons = true;

  try {
    const cart = await fetch("/cart.js");
    const cartData = await cart.json();
    const { items } = cartData;
    const cartDrawerUpsells = document.querySelector(".m-cart-drawer__upsells");
    cartDrawerUpsells.innerHTML = "";
    cartDrawerUpsells.classList.remove("loaded");

    const sortedItems = items.sort((a, b) => b.original_price - a.original_price);


    for (const item of sortedItems) {
      const productId = item.product_id;
      const productUpsells = await fetch(
        `https://api.fastbundle.co/v3/product-bundles/?shop=c53d6f-2.myshopify.com&product_id=${productId}&lang=en`,
        {
          headers: {
            Authorization: "Bearer YOUR_TOKEN_HERE",
            "Content-Type": "application/json",
          },
        }
      );
      const productUpsellsData = await productUpsells.json();
      const addOns = productUpsellsData.filter((item) => item.type === "add_on");
      const bundles = productUpsellsData.filter((item) => item.type !== "add_on");

      if (bundles.length > 0) {
        await renderBundles(bundles, cartDrawerUpsells);
        break;
      }

      if (addOns.length > 0) {
        renderAddOns(addOns[0], cartDrawerUpsells);
        break;
      }

    }
  } catch (error) {
    console.error("Error in setCartAddons:", error);
  } finally {
    isSettingCartAddons = false;
  }
}

async function renderBundles(bundles, upsellsContainer) {

  const bundlesTitle = createElementWithClasses("h3", ["m-cart-drawer__upsells--title"]);
  bundlesTitle.textContent = window.cartUpsellsBundlesTitle;
  upsellsContainer.appendChild(bundlesTitle);

  const bundlesContainer = createElementWithClasses("div", ["bundles", "swiper", "swatchesSwiper"]);

  const swiperWrapper = createElementWithClasses("div", ["swiper-wrapper"]);
  bundlesContainer.appendChild(swiperWrapper);

  const swiperButtonNext = createElementWithClasses("div", ["swiper-button-next"]);
  const swiperButtonPrev = createElementWithClasses("div", ["swiper-button-prev"]);

  const bundlePromises = bundles.map(async (bundle) => {
    const bundleContainer = createElementWithClasses("div", [
      "m-cart-drawer__upsells-item",
      "bundle",
      "swiper-slide",
    ]);
    const bundleTitleSpan = createElementWithClasses("span", ["m-cart-drawer__upsells-item-title"]);
    bundleTitleSpan.textContent = bundle.title;
    let bundleImageSrc = "";

    try {
      const bundleImageResponse = await fetch("https://bundleimage-j4htuymeaq-uc.a.run.app", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          productTitle: bundle.title,
        }),
      });
      bundleImageSrc = await bundleImageResponse.json();
    } catch (error) {
      console.error("Error fetching bundle image:", error);
    }

    const bundleImage = createElementWithClasses("img");
    bundleImage.src = bundleImageSrc.imageUrl;
    bundleImage.alt = bundle.title;

    bundleContainer.append(bundleImage, bundleTitleSpan);

    const bundleButton = createElementWithClasses("button", [
      "m-cart-drawer__upsells-item-button",
      "m-button",
    ]);
    const bundleButtonText = document.createElement("span");
    bundleButtonText.textContent = "+ Add To Cart";

    const spinnerIcon = document.createElement("span");
    spinnerIcon.className = "m-spinner-icon";
    spinnerIcon.innerHTML = `
      <svg
        class="animate-spin m-svg-icon--medium"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `;

    bundleButton.append(bundleButtonText, spinnerIcon);

    bundleButton.addEventListener("click", () => {
      bundleButton.classList.add("m-spinner-loading");
      rbrShowFunnel(bundle);
      setTimeout(() => {
        bundleButton.classList.remove("m-spinner-loading");
      }, 300);
    });
    bundleContainer.appendChild(bundleButton);


    return bundleContainer;
  });

  const bundleElements = await Promise.all(bundlePromises);
  swiperWrapper.append(...bundleElements);

  bundlesContainer.append(swiperWrapper, swiperButtonNext, swiperButtonPrev);
  upsellsContainer.appendChild(bundlesContainer);
  new Swiper(bundlesContainer, {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
  upsellsContainer.classList.add("loaded");
}

function renderAddOns(addOns, upsellsContainer) {
  const createAddonItem = ({ image, title, id, handle }) => {
    const addOnItem = createElementWithClasses("div", [
      "m-cart-drawer__upsells-item",
      "addOn",
      "swiper-slide",
    ]);

    const addonImage = createElementWithClasses("img");
    addonImage.src = image;
    addonImage.alt = title;

    const addonTitle = createElementWithClasses("span");
    addonTitle.classList.add("m-cart-drawer__upsells-item-title");
    addonTitle.textContent = title;

    const quickAddButton = createElementWithClasses("button", [
      "m-product-form",
      "m:w-full",
      "m-product-quickview-button",
      "m-spinner-button",
      "m-button",
      "m-button--primary",
    ]);
    quickAddButton.dataset.productUrl = `/products/${handle}`;
    quickAddButton.dataset.productId = id;
    quickAddButton.dataset.productHandle = handle;

    const spinnerIcon = document.createElement("span");
    spinnerIcon.className = "m-spinner-icon";
    spinnerIcon.innerHTML = `
      <svg
        class="animate-spin m-svg-icon--medium"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
      >
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
    `;

    const buttonText = document.createElement("span");
    buttonText.textContent = "+ Add To Cart";

    quickAddButton.append(spinnerIcon, buttonText);
    addOnItem.append(addonImage, addonTitle, quickAddButton);
    return addOnItem;
  };

  const addOnsContainer = createElementWithClasses("div", ["addOns", "swiper", "swatchesSwiper"]);

  const swiperWrapper = createElementWithClasses("div", ["swiper-wrapper"]);
  const swiperButtonNext = createElementWithClasses("div", ["swiper-button-next"]);
  const swiperButtonPrev = createElementWithClasses("div", ["swiper-button-prev"]);
  const addonsTitle = createElementWithClasses("h3", ["m-cart-drawer__upsells--title"]);
  addonsTitle.textContent = window.cartUpsellsAddonsTitle;

  const validAddons = addOns.items.filter(
    (item) =>
      item.is_add_on &&
      !item.variants.every(
        (variant) => variant.inventory_policy === "deny" && variant.quantity <= 0
      )
  );

  swiperWrapper.append(...validAddons.map(createAddonItem));

  addOnsContainer.append(swiperWrapper, swiperButtonNext, swiperButtonPrev);
  upsellsContainer.appendChild(addonsTitle);
  upsellsContainer.appendChild(addOnsContainer);
  upsellsContainer.classList.add("loaded");

  new Swiper(addOnsContainer, {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
const createElementWithClasses = (tag, classes = []) => {
  const element = document.createElement(tag);
  element.classList.add(...classes);
  return element;
};
